import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../app/store";
import { hasModuleReadAccess } from "../features/auth/moduleAccess";

interface ProtectedRouteProps {
	children: React.ReactNode;
	moduleKey?: string;
}

export const ProtectedRoute = ({
	children,
	moduleKey,
}: ProtectedRouteProps) => {
	const { isAuthenticated, user } = useSelector(
		(state: RootState) => state.auth,
	);

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	if (moduleKey && user && !hasModuleReadAccess(user, moduleKey)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <>{children}</>;
};
